<template>
<div id="Atualiza">
  <div class="card text-center">
    <div class="card-header">
      <span> <img id="logo" src="../../assets/logo_kibon.png" class="w-75" alt="Logo"> </span>
      <br/>
      <br/>
      Atualização Cadastral
      <small id="emailHelp" v-if="rca.codusur" class="form-text text-muted">RCA: {{rca.nome}}
         <font-awesome-icon icon="sign-out-alt" v-on:click="logout"/>
      </small>
    </div>
    <div class="card-body">
      <form id="equipamentoForm" v-on:submit.prevent="atualizar">
        <div class="input-group mb-3">
          <input type="text" class="form-control" v-on:blur="carregarCliente" v-model="codCli" placeholder="Código do Cliente" aria-label="Código do Cliente" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <span class="input-group-text btn btn-info" id="basic-addon2" v-on:click="carregarCliente" >
              Carregar
            </span>
          </div>
        </div>    
        <div v-if="newCliente.codcli" class="card text-white bg-secondary">
          <div class="card-body">
            <h5 class="card-title">{{newCliente.codcli}} - {{newCliente.cliente}}</h5>
          </div>
        </div>
        <br>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1"><font-awesome-icon icon="envelope"/></span>
          </div>
          <input type="email" class="form-control" placeholder="Email" aria-label="Email" aria-describedby="basic-addon1" v-model="newCliente.emailnfe">
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1"><font-awesome-icon icon="phone"/></span>
          </div>
          <input type="number" class="form-control" placeholder="Telefone" aria-label="Telefone" aria-describedby="basic-addon1" v-model="newCliente.telent">
        </div>
        <div class="input-group mb-3">
          <button class="btn btn-primary btn-block" type="submit">Atualizar</button>
        </div>
      </form>
    </div>
  </div>
</div>
</template>
<script>
const fb = require('../../config/db.js')

export default {
  name: 'Atualiza',
  data(){
    return {
      codCli: '',
      rca: {
        'id': '',
        'codusur': '',
        'nome': ''
      },
      newCliente : {
        'id': '',
        'codcli': '',
        'cliente': '',
        'codusur1': '',
        'emailnfe': '',
        'telent': '',
        'alteracao': '',
        'data': ''
      }
    }
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/')
    }else{
      fb.Rcas.where('codusur', '==', this.$session.get('rca')).get().then(querySnapshot =>{
        querySnapshot.forEach((doc)=>{
          this.rca = doc.data();
          this.rca.id = doc.id;
        });
      });
    }
  },
  methods:{
    logout(){
      if (confirm('Deseja realmente sair?')){
        this.$session.destroy();
        this.$router.push('/');
      }
    },
    atualizar(){
      if (this.newCliente.emailnfe == '' && this.newCliente.telent == ''){
        alert('Telefone ou Email obrigatório');
        return;
      }
      if (this.newCliente.id == '')
        alert('Digite o Código do Cliente');
      else {
        if (this.newCliente.emailnfe != '')
          fb.Clientes.doc(this.newCliente.id).update({
            'emailnfe': this.newCliente.emailnfe,
            'alteracaoemail': this.rca.codusur,
            'dataemail': new Date()      
        });
        if (this.newCliente.telent != '')
          fb.Clientes.doc(this.newCliente.id).update({
            'telent': this.newCliente.telent,
            'alteracaotel': this.rca.codusur,
            'datatel': new Date()      
          });
        alert('Atualização concluída!');
        this.newCliente = {
          'id': '',
          'codcli': '',
          'cliente': '',
          'codusur1': '',
          'emailnfe': '',
          'telent': '',
          'alteracao': '',
          'data': ''
        };
      }
    },
    carregarCliente(){
      if (this.codCli == ''){
        this.newCliente = {
          'id': '',
          'codcli': '',
          'cliente': '',
          'codusur1': '',
          'emailnfe': '',
          'telent': '',
          'alteracao': '',
          'data': ''
        };
      }else{
        this.newCliente = {
          'id': '',
          'codcli': '',
          'cliente': '',
          'codusur1': '',
          'emailnfe': '',
          'telent': '',
          'alteracao': '',
          'data': ''
        };
        fb.Clientes.where('codcli', '==', this.codCli).where('codusur1', '==', this.rca.codusur).get().then(querySnapshot =>{
          querySnapshot.forEach((doc)=>{
            this.newCliente.codcli = doc.data().codcli;
            this.newCliente.cliente = doc.data().cliente;
            this.newCliente.id = doc.id;
          });
        });
      }
      this.codCli = '';
      
      
    }
  }
}
</script>
<style scoped>
</style>
